import { render, staticRenderFns } from "./OrganizationTitle.vue?vue&type=template&id=8fd07304&"
import script from "./OrganizationTitle.vue?vue&type=script&lang=js&"
export * from "./OrganizationTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports